document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 16);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const images = root.querySelectorAll('[data-gallery-image]');
    images.forEach((button) => {
      button.addEventListener('click', () => {
        images.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('.quick-add-form').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('button');
      if (!button) return;
      button.textContent = 'Adding...';
      button.setAttribute('aria-busy', 'true');
    });
  });
});
